// src/user/ForgotPassword.js

import React, { useState } from 'react';
import { useNavigate }      from 'react-router-dom';
import { auth }             from '../firebase';                 // ← one “..” to src/firebase.js
import { sendPasswordResetEmail } from 'firebase/auth';
import './ForgotPassword.css';                                 // ← CSS in same folder

export default function ForgotPassword() {
  const [email, setEmail]             = useState('');
  const [submitted, setSubmitted]     = useState(false);
  const [errors, setErrors]           = useState({});
  const [firebaseError, setFirebaseError] = useState('');
  const navigate                      = useNavigate();

  const handleChange = e => {
    setEmail(e.target.value);
    setErrors({});
    setFirebaseError('');
  };

  const validate = () => {
    const newErrors = {};
    if (!email) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Email is invalid.';
    }
    return newErrors;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setSubmitted(true);
      setTimeout(() => navigate('/login'), 5000);
    } catch (err) {
      setFirebaseError(err.message);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div id="forgot-password-page">
      <div className="fp-form-panel">
        <h2 className="fp-content-title">Forgot Password</h2>

        {!submitted ? (
          <form className="fp-form" onSubmit={handleSubmit}>
            {errors.email && (
              <div className="fp-error-box">{errors.email}</div>
            )}
            {firebaseError && (
              <div className="fp-error-box">{firebaseError}</div>
            )}

            <label htmlFor="fp-email" className="fp-label">
              Email Address
            </label>
            <input
              id="fp-email"
              type="email"
              value={email}
              onChange={handleChange}
              className="fp-input"
              placeholder="you@example.com"
              required
            />

            <button type="submit" className="fp-button-reset">
              Send Reset Link
            </button>
          </form>
        ) : (
          <div>
            <div className="fp-success-box">
              A password reset link has been sent to{' '}
              <strong>{email}</strong>.<br/>
              You’ll be redirected to the login page shortly.
            </div>
            <button
              className="fp-button-back"
              onClick={handleBackToLogin}
            >
              Go Back to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
